import React from 'react'

// Page title block shown at the top of each screen
const PageHeader = ({ title, subtitle, actions }) => {
  return (
    <div className="bl-page-header">
      <div>
        <h2 className="h1">{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="d-flex gap-2 flex-shrink-0">{actions}</div>}
    </div>
  )
}

export default PageHeader
